"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vipCargo: {
    por: 'POR',
    pol: 'POL',
    etd: 'ETD',
    agtd: 'Updated ETD',
    atd: 'ATD',
    pod: 'POD',
    del: 'DEL',
    eta: 'ETA',
    agta: 'Updated ETA',
    ata: 'ATA',
    vessel: 'VSL',
    voyage: 'VOY',
    blNo: 'B/L No.',
    baseInfo: 'Base Info',
    currentVesselMovement: 'Vessel Movement',
    nextLeg: 'Next Leg',
    bkLane: 'LANE',
    bkVVL: 'VVL',
    lane: 'LANE',
    vvl: 'VVL',
    containerNo: 'Container No.',
    containerType: 'Type',
    sealNo: 'Seal No.',
    cargoType: 'Cargo Type',
    quantity: 'Quantity',
    weight: 'Weight',
    size: 'Size',
    currentPort: 'Current Port',
    latestMovement: 'Latest Movement',
    eventDate: 'Event Date',
    eventPort: 'Event Port',
    movementNameEn: 'Movement',
    moreInfo: 'More Info',
    bookingParty: 'Booking Party',
    PIC: 'PIC',
    brokersPIC: 'Brokers PIC',
    shipper: 'Shipper',
    consignee: 'Consignee',
    teu: 'TEU',
    freightName: 'NAC',
    freightNameCn: 'NAC',
    actualDays: 'Actual sailing',
    estimatedDays: 'Estimated sailing',
    view: 'View',
    excel: 'Excel',
    reset: 'Reset'
  }
};